import { render, staticRenderFns } from "./HandsUpForm.vue?vue&type=template&id=2ffd3716&scoped=true&lang=pug&"
import script from "./HandsUpForm.vue?vue&type=script&lang=js&"
export * from "./HandsUpForm.vue?vue&type=script&lang=js&"
import style0 from "./HandsUpForm.vue?vue&type=style&index=0&id=2ffd3716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd3716",
  null
  
)

export default component.exports